<template>
  <div class="d-flex justify-space-between">
    <div class="thumb_div elevation-2">
      <v-img :src="img_src" grey height="200" max-height="200"> </v-img>
    </div>
    <div class="flex-grow-1 pa-4 d-flex pb-0 flex-column justify-space-between">
      <div class="d-flex justify-space-between pb-0 mb-0">
        <div v-if="icon.length > 0">
          <v-icon> {{icon}} </v-icon>
        </div>
        <div class="view-title flex-grow-1" v-if="title.length > 0">
          {{title}}
        </div>
      </div>
      <v-divider></v-divider>
      <div class="d-flex justify-space-between">
        <div v-for="(fact,index) in facts" :key="index"> {{fact.text}} <b class="primary--text">{{fact.val}}</b></div>
      </div>
      <div class="view-description">
        <div class="view-description-content">
          {{description}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViewHeader",
  props: {
    img_src: {
      type: String,
      default: "",
    },
     icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    facts: {
      type: Array,
      default: () => {
        return [];
      },
    },
    description: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.thumb_div {
  background-color: grey;
  height: 200px;
  width: 200px;
}

.view-title {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}

.view-label {
  /* font- */
}

.view-description-content {
  background-color: #cccccc24;
  height: 80px;
  border-radius: 10px;
  font-size: 16px;
  text-align: left;
  padding: 10px;
  color: #000000c7;
}
</style>